import { LineSegment, VictoryAxis, VictoryLabel } from "victory";
import { fonts } from "../../../../Styles";
import { useTranslation } from "react-i18next";
import { consumptionsGraphsStyle } from "../_TenDaysComponentsViewer/consumptionsGraphStyle";
import { ConsumptionsGraphsDayData } from "../_TenDaysComponentsViewer/consumptionsGraphValueTypes";
import { consumptionsGraphsFormatDate } from "../_TenDaysComponentsViewer/consumptionsGraphFormatDate";

// Y-Axis
export const ConsumptionsGraphsAxisY = () => {
  const { t } = useTranslation();

  return (
    <VictoryAxis
      dependentAxis
      offsetX={32}
      standalone={false}
      crossAxis={false}
      tickFormat={(t:number) => (t / 1000)}
      label={t("units.kg", { defaultValue: "KG" })}
      style={{
        ticks: { stroke: consumptionsGraphsStyle.primaryColor, size: 5 },
        axis: { stroke: consumptionsGraphsStyle.primaryColor, strokeWidth: 2 },
      }}
      tickLabelComponent={
        <VictoryLabel
          textAnchor="end"
          style={{ ...fonts.paragraph, fill: consumptionsGraphsStyle.primaryColor, ...consumptionsGraphsStyle.fontSize }}
        />
      }
      axisLabelComponent={
        <VictoryLabel
          angle={0}
          verticalAnchor="start" 
          textAnchor="start"
          x={0}
          y={0}
          style={{ ...fonts.header, fill: consumptionsGraphsStyle.primaryColor, ...consumptionsGraphsStyle.fontSize }}
        />
      }
      axisComponent={
        <LineSegment
          y1={0}
          y2={consumptionsGraphsStyle.chartHeight - 20}
        />
      }
    />
  )
}

// X-Axis
export const ConsumptionsGraphsAxisX = ({ data }: { data: ConsumptionsGraphsDayData[] }) => {
  const { t } = useTranslation();
  const tickValues = data.map(day => consumptionsGraphsFormatDate(day.date));
  
  return (
    <VictoryAxis
      offsetY={25}
      orientation="bottom"
      standalone={false}
      crossAxis={false}
      tickValues={tickValues}
      label={t("units.date", { defaultValue: "Date" })}
      style={{
        ticks: { stroke: consumptionsGraphsStyle.primaryColor, size: 5 },
        axis: { stroke: consumptionsGraphsStyle.primaryColor, strokeWidth: 2 },
      }}
      tickLabelComponent={
        <VictoryLabel
          y={consumptionsGraphsStyle.chartHeight}
          verticalAnchor="end"
          style={{ ...fonts.paragraph, fill: consumptionsGraphsStyle.primaryColor, ...consumptionsGraphsStyle.fontSize }}
        />
      }
      axisLabelComponent={
        <VictoryLabel
          y={consumptionsGraphsStyle.chartHeight}
          x={consumptionsGraphsStyle.chartWidth}
          verticalAnchor="end"
          textAnchor="end"
          style={{ ...fonts.header, fill: consumptionsGraphsStyle.primaryColor, ...consumptionsGraphsStyle.fontSize }}
        />
      }
      axisComponent={
        <LineSegment x1={27} x2={consumptionsGraphsStyle.chartWidth} />
      }
    />
  )
}